// extracted by mini-css-extract-plugin
export default {"galleryWrapper":"l_sFbWp4rOj6OARL5frEV"};